import React from 'react';
import { usePopupManager } from 'ui-builder';
import { Popup, PopupSize } from 'features/nekst-widgets';
import { EditScratchpadForm } from './EditScratchpadForm';
import { ScratchpadContent } from './ScratchpadContent';

import styles from './ScratchpadPopup.module.scss';

interface ScratchpadPopupProps {
  projectId: number;
  text?: string;
  canEdit: boolean;
  onSaved: () => Promise<void>;
}

export function ScratchpadPopup(props: ScratchpadPopupProps) {
  const popupManager = usePopupManager();

  const handleCancel = () => {
    popupManager.closePopup();
  };

  const handleSaved = async () => {
    await props.onSaved();
    popupManager.closePopup();
  };

  const content = props.canEdit ? (
    <div className={styles.editForm}>
      <EditScratchpadForm
        projectId={props.projectId}
        initialText={props.text}
        onCancel={handleCancel}
        onSaved={handleSaved}
      />
    </div>
  ) : (
    <ScratchpadContent
      text={props.text}
      className={styles.content}
      emptyClassName={styles.emptyContent}
    />
  );

  return (
    <Popup
      title="Scratchpad"
      content={content}
      size={PopupSize.WIDE}
      testId="scratchpad-popup"
    />
  );
}
